export var FeatureFlags;
(function (FeatureFlags) {
    FeatureFlags["GRADE_SYNC"] = "lms_gate_grade_sync";
})(FeatureFlags || (FeatureFlags = {}));
//# sourceMappingURL=feature-flags.js.map